export enum EAvaliacaoProgramaTrabalhoQuestao {
  Adequado = 1,
  ParcialmenteAdequado = 2,
  Inadequado = 3,
  NA = 4,
  InformaçõesAdicionais = 5
}

export const EAvaliacaoProgramaTrabalhoQuestaoDescricao = {
  [EAvaliacaoProgramaTrabalhoQuestao.Adequado]: 'Adequado',
  [EAvaliacaoProgramaTrabalhoQuestao.ParcialmenteAdequado]: 'Parcialmente adequado',
  [EAvaliacaoProgramaTrabalhoQuestao.Inadequado]: 'Inadequado',
  [EAvaliacaoProgramaTrabalhoQuestao.NA]: 'N/A - Não se aplica',
  [EAvaliacaoProgramaTrabalhoQuestao.InformaçõesAdicionais]: 'I/A – Informações adicionais'
};